import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanService } from '../shared-component/service/loan/loan.service';

@Component({
  selector: 'app-terms-conditions-bitly',
  templateUrl: './terms-conditions-bitly.component.html',
  styleUrls: ['./terms-conditions-bitly.component.css']
})
export class TermsConditionsBitlyComponent implements OnInit {

  public tokenId: string;
  public loanDetail: any = {};

  constructor(
    private activeRoute: ActivatedRoute,
    private loanService: LoanService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.getLoanDetails();
  }

  getLoanDetails() {
    this.activeRoute.data.subscribe((res: any) => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;
      if (this.loanDetail.termsConditionsAccepted === true) {
        this.router.navigateByUrl(`message`, { replaceUrl: true }).then();
      }
      else {
        this.loanService.loanAcceptingTermsConditions(this.tokenId, {}).subscribe((res: any) => { });
      }
    });
  }

}
